import { createI18n } from "vue-i18n";

import de from "@/json/locales/de.json" with { type: "json" };
import en from "@/json/locales/en.json" with { type: "json" };

type Locale = "de" | "en";

const AVAILABLE_LOCALES: Locale[] = ["de", "en"];

const DEFAULT_LOCALE: Locale = "de";

const locale = determineLocale(globalThis.navigator.languages);

function determineLocale(languages: readonly string[]): Locale {
  for (const language of languages) {
    const matchingLocale = AVAILABLE_LOCALES.find((locale) => language.startsWith(locale));
    if (matchingLocale) {
      return matchingLocale;
    }
  }

  return DEFAULT_LOCALE;
}

export const i18n = createI18n({
  locale,
  defaultLocale: DEFAULT_LOCALE,
  fallbackLocale: [DEFAULT_LOCALE],
  allowComposition: true,
  legacy: false,
  warnHtmlMessage: false, // disable warning HTML in message
  messages: {
    de,
    en,
  },
  datetimeFormats: {
    de: {
      "date-time": {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      },
      date: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      time: {
        hour: "numeric",
        minute: "numeric",
      },
    },
    en: {
      "date-time": {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      },
      date: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      time: {
        hour: "numeric",
        minute: "numeric",
      },
    },
  },
});

export function activateLocale(locale: string) {
  if (isAvailableLocale(locale)) {
    i18n.global.locale.value = locale;
  } else {
    // eslint-disable-next-line no-console
    console.warn(`Tried to activate unknown locale “${locale}”.`);
  }
}

function isAvailableLocale(locale: string): locale is Locale {
  return AVAILABLE_LOCALES.some((availableLocale) => availableLocale === locale);
}
